import React from 'react';

const ProjectcsBanner = () => {
  return (
    <div className="services-banner project-banner">
      <div className="container">
        <div className="services-banner-wrapper">
          <h1>Our Projects</h1>
          <p>
            Our dynamic and impactful projects demonstrate Quantome's commitment
            to innovation and excellence in the financial industry.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProjectcsBanner;
